import settings from '@config/settings';
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

Sentry.init({
  dsn: settings.logging.sentry.url,
  normalizeDepth: 10,
  replaysSessionSampleRate: settings.logging.sentry.replaysSessionSampleRate,
  replaysOnErrorSampleRate: 1.0,
  enabled: settings.logging.sentry.enabled,
  release: settings.release,
  environment: settings.environment === '' ? 'PROD' : settings.environment,
  maxValueLength: 1000,
  tracesSampleRate: settings.logging.sentry.performanceSampleRate,
  integrations: [
    // See docs for support of different versions of variation of react router
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
    // Sentry.captureConsoleIntegration({ levels: ['error'] }), // this logs console errors as new errors, but we should use logAndCaptureException instead
    // this allows the user to send issues to sentry
    Sentry.feedbackIntegration({
      // Additional SDK configuration goes in here, for example:
      autoInject: settings.logging.sentry.allowFeedback,
      colorScheme: 'system',
      showBranding: false,
      triggerLabel: 'Feedback',
      formTitle: 'Feedback/probleem melden',
      submitButtonLabel: 'Feedback versturen',
      cancelButtonLabel: 'Annuleren',
      confirmButtonLabel: 'Bevestigen',
      addScreenshotButtonLabel: 'Voeg een screenshot toe',
      removeScreenshotButtonLabel: 'Screenshot verwijderen',
      nameLabel: 'Naam',
      namePlaceholder: 'Naam',
      emailLabel: 'E-mail',
      emailPlaceholder: 'E-mail',
      isRequiredLabel: '(verplicht)',
      messageLabel: 'Bericht',
      messagePlaceholder: 'Beschrijf het probleem of geef feedback',
      successMessageText: 'Bedankt voor je feedback!',
    }),
  ],
  beforeSend(event) {
    // Remove request and response data from the event
    if (event.breadcrumbs) {
      event.breadcrumbs = event.breadcrumbs.filter(
        (breadcrumb) =>
          !breadcrumb.message?.startsWith('An input selector returned a different result'),
      );
    }
    return event;
  },
});
